import { VList } from '@sleepstation/components-layouts'
import { LAYOUT_SPACING } from '@sleepstation/const'
import { renderList } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import Question from './Question'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VList).attrs({ spacing: LAYOUT_SPACING.LARGE })``

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const QuestionList = ({ questions }) => (
  <Layout>
    {renderList(
      ({ title, body }) => (
        <Question title={title} body={body} />
      ),
      questions
    )}
  </Layout>
)

QuestionList.propTypes = {
  questions: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default QuestionList
